import React, { useEffect, useState } from "react";
import { CustomersFileType } from "../Common/Types/types";
interface NetworkDiagramThumbProps {
  latestItem: CustomersFileType;
  customerId: String;
}

const NetworkDiagramThumb = (props: NetworkDiagramThumbProps) => {
  useEffect(() => {}, []);
  const openLarge = () => {
    window.open("/NetworkDiagram?customerId=" + props.customerId, "_blank");
  };
  return (
    <>
      {" "}
      Click image to enlarge in new tab.
      <img
        id="diag"
        src={props.latestItem.url}
        style={{
          margin: "auto",
          cursor: "pointer",
          border: "1px solid #000",
          padding: "10px",
          backgroundColor: "#fff",
          width: "100px",
        }}
        onClick={() => openLarge()}
      />
    </>
  );
};
export default NetworkDiagramThumb;
